import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const SET_LANGUAGE = "setLanguage";
const GET_OTHER_NETWORKS = "getOtherNetworks";
const LOGOUT = "logout";
const CONTACT_US = "contactUs";
const PRAYER_REQUEST = "prayerRequest";

const memberToolbarKeys = createKeys(featureKeys.MEMBER_TOOLBAR, {
  setLanguage: () => [SET_LANGUAGE],
  getOtherNetworks: () => [GET_OTHER_NETWORKS],
  logout: () => [LOGOUT],
  contactUs: () => [CONTACT_US],
  prayerRequest: () => [PRAYER_REQUEST],
});

export default memberToolbarKeys;
